// import { display } from 'html2canvas/dist/types/css/property-descriptors/display';
// import { display } from 'html2canvas/dist/types/css/property-descriptors/display';
// import { fontFamily } from 'html2canvas/dist/types/css/property-descriptors/font-family';
// import { overflow } from 'html2canvas/dist/types/css/property-descriptors/overflow';
// import { overflow } from 'html2canvas/dist/types/css/property-descriptors/overflow';
// import { BorderBottom } from '@mui/icons-material';
import styled from 'styled-components';

export const MARGIN_TOP = 28;

export const styles = {
  root: {
    flex: 1,
  },
  noClaimWrapper: { marginTop: '50%', alignItems: 'center', justifyContent: 'center' },
  noClaimSvg: { marginBottom: 16 },
  noClaimTitle: { marginBottom: 16 },
  mainView: { flex: 1 },
  title: { marginBottom: 8 },
  paymentItem: { marginBottom: 8 },
  totalAmount: { fontSize: 24 },
  selectPaymentTitle: { margin: 18, fontSize: 24 },
  selectPaymentInfoWrapper: {
    paddingVertical: 8,
    paddingHorizontal: 16,
    flexDirection: 'row',
  },
  selectPaymentInfoIcon: { flexShrink: 0, marginRight: 6 },
  selectPaymentInfoText: { flexShrink: 1 },
  container: {
    overflow: 'hidden',
    width: '100%',
    backgroundColor: '#EBEBEB',
  },
  table: {
    width: '100%',
  },
  tableRow: {
    display: 'flex',
    justifyContent: 'space-between',
    overflow: 'hidden',
    paddingTop: '10px',
    paddingBottom: '10px',
  },
  tableColumn: {
    width: '50%',
    borderLeft: '1px solid #ccc',
    padding: '10px',
    marginLeft: '-1px',

    borderLeftColor: '#CCCCCC',
  },
  tableHeader: {
    display: 'block',
    width: '100%',

    fontFamily: 'Roboto500',
    fontSize: 17,
  },
  divider: {
    height: 1,
    backgroundColor: '#ccc',
    marginVertical: 5,
  },
  normalText: {
    display: 'block',
    width: '100%',

    fontFamily: 'Roboto400',
    fontSize: 17,
  },
  normalText20px: {
    display: 'block',
    width: '100%',

    fontFamily: 'Roboto400',
    fontSize: 20,
  },
  normalText33px: {
    padding: '16px',
    display: 'block',
    width: '100%',
    backgroundColor: 'white',
    fontFamily: 'Roboto400',
    fontSize: 33,
    borderBottom: '1px solid #ccc',
  },
  tableRowWithDivider: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottomWidth: 1,
    borderBottomColor: '#ccc',
    paddingVertical: 5,
  },
  steps: {
    display: 'block',
    width: '100%',
    fontSize: 22,
    fontFamily: 'Roboto400',
    marginBottom: 10,
  },
  icon: {
    height: '100%',
    marginRight: 10,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginTop: 4,
  },
};

export const CardContainer = styled.div`
  margin-top: ${20}px;
  margin-left: ${18}px;
  margin-right: ${18}px;
  margin-bottom: ${20}px;
`;

export const Card = styled.div`
  background-color: #fff;
  border-radius: ${12}px;
  width: '100%';
  margin-bottom: ${15}px;
`;

export const CodeButton = styled.span`
  background-color: #fff;
  color: #c21b17;
  padding-left: ${5}px;
  padding-right: ${5}px;
  padding-top: ${3}px;
  padding-bottom: ${3}px;
  font-weight: bold;
  text-align: center;
  border-width: ${1}px;
  border-color: #c21b17;
  border-style: solid;
`;

export const PayButton = styled.span`
  background-color: #c21b17;
  color: #fff;
  padding-left: ${7}px;
  padding-right: ${7}px;
  padding-top: ${5}px;
  padding-bottom: ${5}px;
  font-weight: bold;
  text-align: center;
`;

export const PayContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-right: ${10}px;
  padding-left: ${10}px;
  padding-top: ${10}px;
  padding-bottom: ${10}px;
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding-left: ${10}px;
  padding-top: ${10}px;
  padding-bottom: ${10}px;
  border-bottom-width: ${1}px;
  border-bottom-color: #ddd;
`;

export const BottomContainer = styled.div`
  padding-left: ${10}px;
  padding-top: ${10}px;
  padding-bottom: ${10}px;
  border-top-width: ${1}px;
  border-top-color: #ddd;
`;

export const Active = styled.span`
  padding-left: ${5}px;
  padding-top: ${5}px;
  padding-bottom: ${5}px;
  padding-right: ${5}px;
  color: #fff;
  background-color: #7ed31f;
  width: ${90}px;
  text-align: center;
  border-radius: ${30}px;
  margin-bottom: ${4}px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
